import type { StaticLayerPayload } from "@config";
import { GridLibrary } from "@library-elements/grid";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: GridLibrary,
};

export const Grid = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
